import { render, staticRenderFns } from "./CustomerViewSidebar.vue?vue&type=template&id=1fd270ee&"
import script from "./CustomerViewSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerViewSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd270ee')) {
      api.createRecord('1fd270ee', component.options)
    } else {
      api.reload('1fd270ee', component.options)
    }
    module.hot.accept("./CustomerViewSidebar.vue?vue&type=template&id=1fd270ee&", function () {
      api.rerender('1fd270ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/partials/CustomerViewSidebar.vue"
export default component.exports